const MODULOS_DO_EAN13 = 113
const DPI_DE_REFERENCIA = 203
const CM_POR_POLEGADA = 2.54
export const MODULO_MINIMO_LEGIVEL_EM_DOTS = 2
export const MODULO_MAXIMO_EM_DOTS = 10

export function larguraDeCodigoDeBarrasEmCm(moduloEmDots: number): number {
	return Math.ceil((MODULOS_DO_EAN13 * moduloEmDots * CM_POR_POLEGADA) / DPI_DE_REFERENCIA * 100) / 100
}

export const LARGURA_MINIMA_DO_CODIGO_DE_BARRAS_CM = larguraDeCodigoDeBarrasEmCm(MODULO_MINIMO_LEGIVEL_EM_DOTS)

export function larguraDoSimboloEmCm(moduloEmDots: number): number {
	return (MODULOS_DO_EAN13 * moduloEmDots * CM_POR_POLEGADA) / DPI_DE_REFERENCIA
}

export function moduloDoCodigoDeBarrasEmDots(larguraCm: number): number {
	const larguraEmDots = Math.round((larguraCm * DPI_DE_REFERENCIA) / CM_POR_POLEGADA)
	return Math.max(1, Math.min(MODULO_MAXIMO_EM_DOTS, Math.floor(larguraEmDots / MODULOS_DO_EAN13)))
}

export function moduloEmCm(moduloEmDots: number): number {
	return (moduloEmDots * CM_POR_POLEGADA) / DPI_DE_REFERENCIA
}

export const ALTURA_MINIMA_DO_CODIGO_DE_BARRAS_CM = 1.2

export const CASAS_DECIMAIS_DO_EDITOR = 1

export const LARGURA_MINIMA_PRATICA_DO_CODIGO_DE_BARRAS_CM =
	Math.ceil(LARGURA_MINIMA_DO_CODIGO_DE_BARRAS_CM * 10 ** CASAS_DECIMAIS_DO_EDITOR) / 10 ** CASAS_DECIMAIS_DO_EDITOR

export function cabeEan13Legivel(larguraCm: number): boolean {
	return moduloDoCodigoDeBarrasEmDots(larguraCm) >= MODULO_MINIMO_LEGIVEL_EM_DOTS
}

export function saiEmEan13(larguraCm: number, alturaCm: number): boolean {
	return cabeEan13Legivel(larguraCm) && alturaCm >= ALTURA_MINIMA_DO_CODIGO_DE_BARRAS_CM
}

